import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("city-list", {
    model: {
      defaults: {
        draggable: true,
        droppable: false,
        components: html`
          <section class="py-6 container mx-auto px-4 ">
            <div class="px-4 py-6">
              <h2 class="text-2xl md:text-3xl font-semibold  mb-6">
                Cities and Regions Covered
              </h2>
              <div class="flex flex-wrap gap-2">
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Birtamode</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Biratnagar</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Malangawa</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Phidim</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Lahan</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Hariwan</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Illam</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Golbazar</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Chapur</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Tamplegunj</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Mirchaiya</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Nijgadh</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Terathathum</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Gaighat</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Kalaiya</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Damak</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Dhalkebar</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Birgunj</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Itahari</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Janakpur</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Simara</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Khadbari</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Bardibas</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Hetauda</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Bhojpur</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Sindhuli</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Narayanghat</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Dharan</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Lalbandi</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Tandi</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Kawasoti</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Butwal</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Sunwal</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Bardaghat</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Bhairahawa</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Parasi</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Pokhara</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Abukhaireni</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Walling</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Beni</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Syanja</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Dang</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Dhangadhi</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Tikapur</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Mahendranagar</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Nepalgunj</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Damauli</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Abukhaireni</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Kohalpur</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Surkhet</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Dedeldhura</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Jumla</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Darchula</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Doti</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Baitadi</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Achham</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Khotang</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Okhaldhunga</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Ramechhap</span
                >
                <span
                  class="px-4 py-1 border border-gray-300 rounded-md text-sm"
                  >Charikot</span
                >
              </div>
            </div>
          </section>
        `,
        // traits: [
        //   {
        //     type: "text",
        //     name: "icon",
        //     label: "Icon",
        //     changeProp: true,
        //   },
        //   {
        //     type: "text",
        //     name: "title",
        //     label: "Title",
        //     changeProp: true,
        //   },
        // ],
      },
    },
  });
};
